import { parseAbi } from 'viem';
export const LEGACY = Object.freeze({
  director: '0xb94b054476b1a84A28843104Fb01dbeb5E8168aF',
  team: '0x19Fa7DEdCD1667Fb12b04b22B3Cc4EA3344074e2',
  pct: '0xE1b3d3f9302FB84C8d5B9e13cd8160fEE67Ea239',
  usdt: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
});
// Deliberately separate from current xPCT and all transaction services.
export const LEGACY_ABI = parseAbi([
  'function totalSupply() view returns (uint256)',
  'function balanceOf(address) view returns (uint256)',
  'function dividendOf(address) view returns (uint256)',
  'function accumulativeDividendOf(address) view returns (uint256)',
  'function lastClaimTimes(address) view returns (uint256)',
  'function claimWait() view returns (uint256)',
  'function balanceOfShares(address) view returns (uint256)',
  'function balanceOfAvailable(address) view returns (uint256)',
]);
export const TTL = 60000;
